import { Network, PaymentMethod, Token } from 'config/types'
import Column from 'layout/Components/Column'
import { useTokenInfo, useTokenPaymentMethod } from 'state/app/hooks'
import { FlexProps } from 'UIKit/Box/types'
import { isHPNNetwork } from 'utils/network'
import HUSDInfo from 'views/Payment/components/HUSDInfo'

import { Trans } from 'react-i18next'
import Flex from 'UIKit/Box/Flex'
import { PaymentPageEnums } from 'views/Payment/Menu'
import SelectedNetworkItem from '../../components/SelectedNetworkItem'
import { PaymentCurrencyBlockMessage, PaymentLabel } from '../../components/styles'
import { IBonusControl } from '../../types'
import DepositByContract from './DepositByContract'
import DepositByQRCode from './DepositByQRCode'

const DepositForm: React.FC<
  {
    selectedToken: Token
    selectedNetwork: Network
    bonusControl: IBonusControl

    onChangeDepositing: (loading: boolean) => void
    onRedirectToSwap: () => void
    isDepositing: boolean
    onSelectToken?: (token: Token) => void
  } & FlexProps
> = ({
  selectedToken,
  onSelectToken,
  selectedNetwork,
  isDepositing,
  onChangeDepositing,
  onRedirectToSwap,
  bonusControl,
  ...props
}) => {
  const currencyInfo = useTokenInfo(selectedToken)
  const method = useTokenPaymentMethod(selectedToken)

  return (
    <Column gap="var(--pm-space-component, 20px)" {...props}>
      {currencyInfo.disabledDeposit ? (
        <>
          <Flex flexDirection="column" display={['flex', '', '', 'none !important']} gap="var(--pm-space-label, 8px)">
            <PaymentLabel>
              <Trans>Network</Trans>
            </PaymentLabel>
            <SelectedNetworkItem
              selectedNetwork={selectedNetwork}
              selectedToken={selectedToken}
              onSelectToken={onSelectToken}
              from={PaymentPageEnums.Deposit}
            />
          </Flex>
          <PaymentCurrencyBlockMessage currency={selectedToken} page={PaymentPageEnums.Deposit} />
        </>
      ) : isHPNNetwork(selectedToken?.network) ? (
        <HUSDInfo onRedirectToSwap={onRedirectToSwap} />
      ) : method === PaymentMethod.TransferToken ? (
        <DepositByQRCode
          selectedNetwork={selectedNetwork}
          selectedToken={selectedToken}
          bonusControl={bonusControl}
          onSelectToken={onSelectToken}
        />
      ) : (
        <DepositByContract
          onChangeDepositing={onChangeDepositing}
          isDepositing={isDepositing}
          selectedNetwork={selectedNetwork}
          selectedToken={selectedToken}
          bonusControl={bonusControl}
          onSelectToken={onSelectToken}
        />
      )}
    </Column>
  )
}

export default DepositForm
